import { MenuServices } from './../../menu/services';
import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { ComboCreateTitlePage } from '../../combo/combo-create/combo-create-title/combo-create-title';
import { ComboListPage } from '../../combo/combo-list/combo-list';
import { MenuListPage } from '../../menu/menu-list/menu-list';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { MenuCreateTitlePage } from '../../menu/menu-create/menu-create-title/menu-create-title';

/**
 * Generated class for the HeaderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-top-menu-combo',
  templateUrl: 'top-menu-combo.html',
})
export class TopMenuComboPage {
  @Input() type;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public menuServices: MenuServices) {

  }

  activeTab(value) {
    if (this.type == value) {
      let cssClasses = {
        'active': true,
        'nav-link': true,
        'space-norwap': true,
        'text-uppercase': true
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'active': false,
        'nav-link': true,
        'space-norwap': true,
        'text-uppercase': true
      }
      return cssClasses;
    }
  }

  openMenuList() {
    this.navCtrl.push(MenuListPage);
  }

  openComboList() {
    this.navCtrl.push(ComboListPage);
  }

  menuCreate() {
    var max_menus = this.menuServices.menus_array.length;
    if (max_menus >= this.globals.checkLimitsByLicense('daily_menu', 'limit') && this.globals.checkLimitsByLicense('daily_menu', 'limit') != -1) { //Si hay limite de menus
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {
      this.globals.tourLaunchStep(2);
      this.navCtrl.push(MenuCreateTitlePage, {
        update_state: false,
      });
    }
  }

  comboCreate() {
    var max_combo = this.menuServices.combos_array.length;
    if (max_combo >= this.globals.checkLimitsByLicense('daily_menu', 'limit_combo') && this.globals.checkLimitsByLicense('daily_menu', 'limit_combo') != -1) { //Si hay limite de combo
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {
      this.navCtrl.push(ComboCreateTitlePage, {
        update_state: false,
        type: 'combo',
      });
    }
  }
  searchMenusCombos(value) {
    this.menuServices.searchbar_text = value;
    //if ver si estamos en menus o combos
    if (this.type == "combo") {
      this.menuServices.filterCombo(value);
    } else {
      this.menuServices.filterMenu(value);
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/components/top-menu-combo/top-menu-combo.ts